import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import { Capacitor } from '@capacitor/core';

// Configure native status bar per platform
if (Capacitor.isNativePlatform()) {
  const isAndroid = Capacitor.getPlatform() === 'android';
  import('@capacitor/status-bar').then(({ StatusBar, Style }) => {
    if (isAndroid) {
      // Android: env(safe-area-inset-top) returns 0px, so don't overlay
      StatusBar.setOverlaysWebView({ overlay: false });
      StatusBar.setBackgroundColor({ color: '#0f172a' }); // navy-900
    } else {
      // iOS: let web content extend behind status bar (safe-area CSS handles padding)
      StatusBar.setOverlaysWebView({ overlay: true });
    }
    StatusBar.setStyle({ style: Style.Light });
  }).catch(() => {});
}

// Enable Firebase Analytics on native so GA4 receives events (session/screen +
// app_open). Without this the app sends nothing → no GA4 data → no BigQuery
// export → no crash-free denominator for the stability metric.
if (Capacitor.isNativePlatform()) {
  import('@capacitor-firebase/analytics').then(({ FirebaseAnalytics }) => {
    FirebaseAnalytics.setEnabled({ enabled: true });
    FirebaseAnalytics.logEvent({ name: 'app_open' });
  }).catch(() => {});
}

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter> {/* Wrap the entire app in BrowserRouter */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
